(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["from-farm"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(!root || root.dataset.ffReady) return;
    root.dataset.ffReady = '1';
    var track = root.querySelector('[data-ff-track]');
    if(!track) return;
    var slides = [].slice.call(track.querySelectorAll('[data-ff-slide]'));
    if(!slides.length) return;
    var dots = [].slice.call(root.querySelectorAll('[data-ff-dot]'));
    var prev = root.querySelector('[data-ff-prev]');
    var next = root.querySelector('[data-ff-next]');
    var idx = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-ff-autoplay'), 10) || 0;
    var rtl = getComputedStyle(track).direction === 'rtl';
    function setActive(n){
      idx = n;
      for(var k=0;k<dots.length;k++){
        var on = k === n;
        dots[k].classList.toggle('active', on);
        dots[k].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }
    function go(n, smooth){
      n = ((n % slides.length) + slides.length) % slides.length;
      slides[n].scrollIntoView({behavior: (smooth === false || reduce) ? 'auto' : 'smooth', inline: 'start', block: 'nearest'});
      setActive(n);
    }
    if(next) next.addEventListener('click', function(){ go(idx + 1); resetTimer(); });
    if(prev) prev.addEventListener('click', function(){ go(idx - 1); resetTimer(); });
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); resetTimer(); }); });
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ var i = slides.indexOf(e.target); if(i > -1) setActive(i); } });
      }, {root: track, threshold: 0.6});
      slides.forEach(function(s){ io.observe(s); });
    }
    function start(){ if(interval > 0 && !reduce && slides.length > 1 && !timer){ timer = setInterval(function(){ go(idx + 1); }, interval); } }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } }
    function resetTimer(){ stop(); start(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function(){ if(document.hidden){ stop(); } else { start(); } });
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function(e){
      stop();
      if(e.pointerType === 'touch') return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('is-grab');
      try { track.setPointerCapture(e.pointerId); } catch(_){}
    });
    track.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - sx;
      if(Math.abs(dx) > 3) moved = true;
      track.scrollLeft = sl - dx;
    });
    function endDrag(){ if(!down) return; down = false; track.classList.remove('is-grab'); start(); }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('keydown', function(e){
      var fwd = (e.key === 'ArrowRight' && !rtl) || (e.key === 'ArrowLeft' && rtl);
      var back = (e.key === 'ArrowLeft' && !rtl) || (e.key === 'ArrowRight' && rtl);
      if(fwd){ e.preventDefault(); go(idx + 1); resetTimer(); }
      else if(back){ e.preventDefault(); go(idx - 1); resetTimer(); }
    });
    setActive(0);
    start();
  }
  function boot(ctx){ [].slice.call((ctx || document).querySelectorAll('[data-ff]')).forEach(init); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', function(){ boot(); }); }
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector ? e.target.querySelector('[data-ff]') : null;
    if(!r && e.target.matches && e.target.matches('[data-ff]')) r = e.target;
    if(r){ r.dataset.ffReady = ''; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
